<template lang="pug">
.ssp-data
  template(v-if="frameStore.showFrame")
    div(v-for="rerun in frameStore.activeRerunsOrdered", :key="rerun")
      AreaLayer(
        :url="`${Env.hscMapData(rerun)}/area.json`",
        :frameStore="frameStore"
      )
  FieldName(v-if="frameStore.showFieldName", :alpha="0.5")
</template>


<script lang="ts">
import Vue from 'vue'
import AreaLayer from "./AreaLayer";
import FieldName from "./FieldName";

export default Vue.extend({
  components: {
    AreaLayer,
    FieldName,
  },
  props: {
    frameStore: { required: true },
  },
})
</script>